import React, { FC } from 'react';
import styled from 'styled-components';
import { Text } from 'src/components/text/Text';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';
import { colors } from 'src/styles/colors';
import { translate, translationKeys } from 'logic/translations/translations.service';

const Type = styled.div<{ minTablet: boolean; active: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${colors.white};
  width: ${({ minTablet }) => (minTablet ? '360px' : '100%')};
  height: ${({ minTablet }) => (minTablet ? '360px' : '150px')};
  border: 1px solid ${({ active }) => (!active ? colors.gray15 : colors.primary)};
  border-radius: 10px;
  user-select: none;
  cursor: pointer;
  box-shadow: ${({ active }) =>
    !active ? '0 2px 6px 0 rgba(0, 0, 0, 0.16)' : '0 20px 40px 0 rgba(12,12,12,0.1)'};
  margin-right: ${({ minTablet }) => (minTablet ? '23px' : '17px')};
  &:last-child {
    margin-right: 0;
  }
  & img,
  span {
    max-width: ${({ minTablet }) => (minTablet ? '185px' : '65px')};
  }
`;

type Props = {
  icon: string;
  active: boolean;
  idx: number;
  type: string;
  onClick: (idx: number) => void;
};

export const FAQType: FC<Props> = ({ icon, idx, type, active, onClick }) => {
  const { minTablet } = useBreakpoints();

  return (
    <Type active={active} minTablet={minTablet} onClick={() => onClick(idx)}>
      <img src={icon} alt={translate(translationKeys.faq.types[type].title)} />
      <Text
        color="black"
        fontWeight={600}
        size={minTablet ? 18 : 14}
        textAlign="center"
        style={{ marginTop: minTablet ? 50 : 12 }}
      >
        {translate(translationKeys.faq.types[type].title)}
      </Text>
    </Type>
  );
};
